import { HiOutlineZoomIn, HiOutlineZoomOut } from 'react-icons/hi';
import { Modal } from '../site/Modal';
import { ThemeSwatchGrid } from '../site/ThemePicker';

export const SettingsModal = ({ isOpen, onClose, settings }) => {
  const { fontSize, changeFontSize } = settings;

  return (
    <Modal isOpen={isOpen} title="Appearance" onClose={onClose}>
      <div className="space-y-6">
        {/* Font Size */}
        <div className="space-y-3">
          <label className="text-xs font-semibold uppercase tracking-wide" style={{ color: 'var(--foreground-muted)' }}>Text Size</label>
          <div
            className="flex items-center gap-4 p-1.5 rounded-2xl border"
            style={{ background: 'var(--background-subtle)', borderColor: 'var(--card-border)' }}
          >
            <button onClick={() => changeFontSize(-0.2)} className="button-ghost p-3.5 rounded-xl transition-all">
              <HiOutlineZoomOut className="w-5 h-5"/>
            </button>
            <div className="flex-1 text-center">
              <span className="text-2xl font-medium" style={{ color: 'var(--foreground)' }}>{fontSize.toFixed(1)}</span>
              <span className="text-xs ml-1" style={{ color: 'var(--foreground-muted)' }}>rem</span>
            </div>
            <button onClick={() => changeFontSize(0.2)} className="button-ghost p-3.5 rounded-xl transition-all">
              <HiOutlineZoomIn className="w-5 h-5"/>
            </button>
          </div>
        </div>

        {/* Theme */}
        <div className="space-y-3">
          <label className="text-xs font-semibold uppercase tracking-wide" style={{ color: 'var(--foreground-muted)' }}>Theme</label>
          <ThemeSwatchGrid />
        </div>
      </div>
    </Modal>
  );
};
